<template>
  <div>
    <b-button variant="outline-light" v-on:click="detayaGit()"
      ><Icon
        icon="mdi:information-slab-box-outline"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'DETAY'"
        color="#FF9F43"
    /></b-button>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: { Icon },
  methods: {
    detayaGit() {
    //  console.log(this.params.data);
      this.$root.$emit("stokLotBilgisi", this.params.data);
    }
  }
};
</script>
